import React from 'react'
import styles from '../../styles'
import { makeStyles } from '@material-ui/core/styles'
import Link from '../link/Link'
import { FormattedMessage, useIntl } from 'react-intl'
import { NewsMarketingModel } from '../../types/news/newsModel'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import parse from 'html-react-parser'
import { formatDateLong } from '../../utils/formatDate'
import { useMediaQuery } from 'react-responsive'
import links from '../../enums/linksEnum'
import { newsEnum } from '../../enums/newsEnum'
import { useHistory, useLocation } from 'react-router'
import { saveInteractions } from '../../modules/gtm/utils/gtmCallback'
import linksEnum from '../../enums/linksEnum'

const useStyle = makeStyles(
	(theme) => (
		{
			...styles(theme),
			marketingStyle: {
				position: 'relative',
				marginTop: 16,
				'& .bloc-container': {
					background: theme.palette.blue.main,
					color: 'white'
				}
			},
			marketingLargeScreenStyle: {
				'& .bloc-container': {
					padding: '68px 0 60px 40px',
					minHeight: 285,
					marginRight: '14%',
					'& > div': {
						width: '50%'
					}
				}
			},
			marketingSmallScreenStyle: {
				paddingTop: 85,
				minHeight: 150,
				width: '100%',

				'& .bloc-container': {
					marginRight: 13.5,
					padding: '150px 16px 60px 24px'
				}
			},

			linkStyle: {
				'& a': {
					marginTop: 20,
					maxWidth: 125
				}
			},
			residenceNameStyle: {
				marginTop: 0
			},
			imgLargeContainer: {
				top: 68,
				right: 0,
				width: 350,
				height: 285,
				position: 'absolute',
				'& img': {
					width: '100%',
					height: '100%',
					objectFit: 'cover'
				}
			},
			imgSmallContainer: {
				width: 264,
				height: 215,
				right: 13.5,
				top: 0,
				position: 'absolute',
				'& img': {
					width: '100%',
					height: '100%',
					objectFit: 'cover'
				}
			}
		}
	)
)

interface AcceptingProps {
	newsMarketing: NewsMarketingModel[],
}

type MarketingProps = AcceptingProps

const Marketing: React.FC<MarketingProps> = (
	{
		newsMarketing
	}
) => {
	const classes = useStyle()
	const history = useHistory()
	const location = useLocation()
	const intl = useIntl()

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1325px)'
		}
	)

	const marketingClass: ClassValue = classNames(
		classes.marketingStyle,
		isLargeScreen ? classes.marketingLargeScreenStyle : classes.marketingSmallScreenStyle
	)

	const residenceNameClass: ClassValue = classNames(
		classes.residenceNameStyle,
		classes.text6_opacity,
		classes.colorWhite
	)

	const imgContainerClass: ClassValue = classNames(
		isLargeScreen ? [classes.imgLargeContainer] : [classes.imgSmallContainer]
	)

	const seeDetails = (id: string, title: string) => {
		saveInteractions(
			{
				category: location.pathname === linksEnum.dashboard ? 'Tableau de bord' : '',
				action: location.pathname === linksEnum.dashboard ? 'Blocs de mise en avant' : '',
				label: `Actualites::${title}`
			}
		)

		history.push(`${links.newsDetails}/${newsEnum.actualite_marketing}/${id}`)
	}

	return (
		<>
			{
				newsMarketing.map(
					(marketing) => (
						<div
							className={marketingClass}
							key={marketing.title}
						>
							<div className="bloc-container">
								<div>
									<p className={residenceNameClass}>
										{formatDateLong(new Date(marketing.beginning), intl.locale)}
									</p>

									<h1 className={isLargeScreen ? classes.title6 : classes.title3}>
										{marketing.title}
									</h1>

									{
										marketing.hook &&
										<div className={isLargeScreen ? classes.text2 : classes.text3_opacity}>
											{parse(marketing.hook)}
										</div>
									}

									<span className={classes.linkStyle}>
										<Link
											onClick={() => seeDetails(marketing.id, marketing.title)}
											color="colorGreen"
											textStyle="text8"
											ariaLabel={
												intl.formatMessage(
													{
														id: 'news.ariaLabel',
														defaultMessage: 'En savoir plus sur l\'actualité : {news}',
														description: 'Aria label text'
													},
													{ news: marketing.title }
												)
											}
										>
											<FormattedMessage
												id="app.details"
												defaultMessage="En savoir plus"
												description="Learn more link"
											/>
										</Link>
									</span>
								</div>
							</div>

							<div className={imgContainerClass}>
								<img
									src={marketing.picture}
									alt={marketing.alternative_text}
								/>
							</div>

						</div>
					)
				)
			}
		</>
	)
}

export default Marketing